// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionChoices_root__-9pe2"};